import {useEffect} from 'react';

// import { Link } from 'react-router-dom';
import AirportCustoms from './AirportCustoms';
import BorderCustoms from './BorderCustoms';
import Documentations from './Documentations';
import SeaPortCustoms from './SeaPortCustoms';



const CustomsBokerages = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
    return(
        <div>
            <div id='international' className="customs-brokerage-image">
                <img src='/customs-brokerage/Customs-Brokerage-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] pb-[1rem]">
                <p>
                    TCS can help shippers, receivers, organisations and enterprises seamlessly comply with physical 
                    characteristics, configurations and material handling standards and regulations that govern 
                    air cargo industry. Our operational procedures, best practices and performance standards 
                    ensure timely clearance of shipments from customs.
                </p>
                {/* <p>
                    We will help you stay ahead of ever-changing custom regulations and compliance laws. With all the variables 
                    and challenges of a global marketplace, a streamlined approach to your customs clearance strategy means 
                    less risk, fewer errors, and reduced costs.
                </p> */}
                
               
                
                 
            </div>
            <div className='mx-[2rem] md:mx-[0rem]'>
            <AirportCustoms/>
            <BorderCustoms/>
            <SeaPortCustoms/>
            <Documentations/>
            </div>
           
        </div>
    )
};
export default CustomsBokerages ;